import { useRef, useEffect } from 'react'

type Props = {
  messageCount: number
  isFetching?: boolean
  doNotScroll?: boolean
}

export const useChatAutoScroll = (props: Props) => {
  const { messageCount, isFetching, doNotScroll = false } = props
  const containerRef = useRef<HTMLDivElement>(null)
  const lastMessageRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (doNotScroll) return
    const container = containerRef.current
    const lastMessageElement = lastMessageRef.current

    if (!container || !lastMessageElement) return

    // Calculate if last message fits in viewport
    const containerHeight = container.clientHeight
    const containerScrollHeight = container.scrollHeight
    const lastMessageRect = lastMessageElement.getBoundingClientRect()

    if (lastMessageRect.height > containerHeight) {
      // Scroll to top of last message
      const spacing = 125
      const targetPosition = containerScrollHeight - lastMessageRect.height - spacing
      container.scrollTo({
        top: targetPosition,
        behavior: 'smooth',
      })
    } else {
      // Regular auto-scroll to bottom
      container.scrollTo({
        top: containerScrollHeight,
        behavior: 'smooth',
      })
    }
  }, [doNotScroll, messageCount])

  useEffect(() => {
    if (doNotScroll) return
    const container = containerRef.current
    if (!container) return

    if (isFetching) {
      container.scrollTo({
        top: container.scrollHeight,
        behavior: 'smooth',
      })
    }
  }, [doNotScroll, isFetching])

  return { containerRef, lastMessageRef }
}
